import { css } from '@emotion/css';
const container = css `
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
`;
export const QrCodeCustomizationsFormStyles = {
    container,
};
//# sourceMappingURL=QrCodeCustomizationsForm.styles.js.map